import React from "react";
import { View, StyleSheet } from "react-native";
import { IMessage, Send, SendProps } from "react-native-gifted-chat";

import { ImgIcon } from "components";

import { icons } from "assets/icons";
import { colors } from "assets/constants";

export default function ChatSend(props: SendProps<IMessage>) {
  return (
    <Send
      {...props}
      children={
        <View style={styles.container}>
          <ImgIcon icon={icons.send} size={25} color={colors.theme} />
        </View>
      }
    />
  );
}

const styles = StyleSheet.create({
  container: {
    width: 45,
    height: 50,
    alignItems: "center",
    justifyContent: "center",
  },
});
